// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1F-pX","col":"styles_col__3vsm6"};